import axios from "@/plugins/http/axios.js";
import config from "@/views/star_assignment/config/star_assignment_api.js";
import configRepor from "@/views/reports/config/reports.js";
import PathUri from "@/utils/path_uri";

const _pathUri = new PathUri(config.port, config.context);
const _pathUriReport = new PathUri(configRepor.port, configRepor.context);

export const service = {
    
  getTypeDocumentStarAssignment: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/core/recognitionAssignmentType`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  getRecognitionAssignmentTypeReport: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/core/recognitionAssignmentTypeReport/`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  getTypeStar: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/shape/allShapeType`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  getCategoryStarAssignment: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/assignmentParametersGroup`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  postStarAssignmentAll: ({ idGroup, idEmpresa, idUsuario, data }) => {
    return axios.post(
      `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/core/assign/massRecognize`,
      {
        ...data,
      },
      {
        headers: {
          "Content-Type": "application/json",
          idEmpresa: idEmpresa,
          idUsuario: idUsuario,
        },
      }
    );
  },

  postStarAssignmentInd: ({ idGroup, idEmpresa, idUsuario, data }) => {
    return axios.post(
      `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/core/assign/individualRecognize`,
      {
        ...data,
      },
      {
        headers: {
          "Content-Type": "application/json",
          idEmpresa: idEmpresa,
          idUsuario: idUsuario,
        },
      }
    );
  },

  getCardsList: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/core/categoryList`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  getAllTemplates: (idGroup, idEmpresa, idUsuario) => {
    return axios({
        method: "get",
        url: `${
          configRepor.baseUrl + _pathUriReport.generateUri() + idGroup
        }/assignment-report/list/reports`,
        headers: {
          idEmpresa: idEmpresa,
          idUsuario: idUsuario,
        },
      });
  },

  scatterStarsTemplates: (idGroup,idEmpresa, idUsuario, document ) => {
    return axios({
        method: 'post',
        url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/recognition/report-assignment`,
        headers:{
            'idEmpresa': idEmpresa,
            'idUsuario': idUsuario 
        },
        data: document,
        redirect: 'follow'
    })
  },

  downloadTemplate: (idGroup,idEmpresa, idUsuario ) => {
    return axios({
      method: "get",
      url: `${configRepor.baseUrl + _pathUriReport.generateUri() + idGroup}/assignment-report/generate/report`, 
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  getTypeStarList: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/startype/`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  postRequestsZen: ( idGroup, idEmpresa, idUsuario, data ) => {
    return axios({
      method: "post",
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/recognition-time/core/assign/individualRecognize`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
      data: data
    });
  },

  getListRequestsZen: ( idGroup, idEmpresa, idUsuario ) => {
    return axios({
      method: "get",
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/zenstars/app/pending-requests`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      }
    });
  },

  getListStarZenStatus: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/zenstars/decisions`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  postStarZenStatus: ({ idGroup, idEmpresa, idUsuario, data }) => {
    return axios({
      method: 'post',
      url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/zenstars/pending-requests/decision`,
      headers:{
          'idEmpresa': idEmpresa,
          'idUsuario': idUsuario 
      },
      data: data,
      redirect: 'follow'
    })
  },

  getJobStatus: (idGroup, idEmpresa, idUsuario, jobId) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/recognition/report-assignment/job/${jobId}`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

};
